import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas">
        <div data-testid="loading-spinner" className="text-stone font-heading text-lg">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/student"} replace />;
  }
  // Gate students whose membership isn't active yet
  if (user.role === "student") {
    const status = user.subscription_status || "active";
    if (["pending_approval", "pending_payment"].includes(status) && !user.trial_active && window.location.pathname !== "/pending-approval") {
      return <Navigate to="/pending-approval" replace />;
    }
  }
  return children;
}
